import React from "react";
import PropTypes from "prop-types";
import { map, size, sortBy, filter, sampleSize } from "lodash";
import css from "cape-style";
// import './Detail.css'
import DetailMap from "./DetailMap";
import LocationList from "./LocationList";
import StudentLink from "../Peers/StudentLink";
import Logo from "../Logo/Logo";
import Wrapper from "../Wrapper/WrapperEl";
import ImageStack from "../StudentDetail/ImageStack";
import Slideshow from "../Slideshow/SlideTest";

import mgsLogo from "../../mgs2018logoarrow.svg";

import {
  MapWrapper,
  MapContainer,
  InfoContainer,
  Title,
  Subtitle,
  Description,
  NameLink,
  Divider,
  Back,
  Loading,
  HideDesktop,
  HideMobile,
  SlideTitle,
  ShowTitle,
} from "./styles";

function AllStudents({ program }) {
  return (
    <div>
      <Divider />
      <ul style={css("m0 mt1 p0 lsNone")}>
        {size(program) > 0 &&
          map(program, ({ students }) =>
            map(sortBy(students, "name"), student => (
              <NameLink hasDetail={student.hasDetail} key={student.id}>
                <StudentLink {...student}>
                  <span className="name">{student.name}</span>
                </StudentLink>
              </NameLink>
            ))
          )}
      </ul>
    </div>
  );
}
AllStudents.propTypes = {
  program: PropTypes.objectOf(PropTypes.object).isRequired
};

function DetailEl({ showGroup, detailClose, allStudentArt }) {

  let picked = null
  console.log(allStudentArt)
  if ( allStudentArt && allStudentArt.length > 0  ) {
    const filtered = filter(allStudentArt, { showGroup: 'rec47bbcAmGcy06c0' })
    picked = sampleSize(filtered, 12)
  }

  if (!showGroup) {
    return <Loading className="flex loading">loading...</Loading>;
  }
  const {
    description,
    extraChild,
    id,
    name,
    lat,
    lng,
    locations,
    program,
    reception,
    show,
    showDate,
    zoom,
    groupType
  } = showGroup;

  const isShowTwo = id === "recesud5HA1rcy0uq";
  const isShowThree = id === "rec47bbcAmGcy06c0";
  const isShowFilm = id === "recR1TeH47Qy4ftSo";
  const firstShow = show[Object.keys(show)[0]] || null;
  const firstStudent =
    (firstShow &&
      firstShow.student &&
      firstShow.student[Object.keys(firstShow.student)[0]]) ||
    null;

  const show3image = "https://mgs20.imgix.net/c6bb209eb8c03d76be0673feca25dfb44adf1675.jpeg"
  return (
    <Wrapper>
      <Back onClick={detailClose}>
        <Logo
          primary
          sttc
          left
          logoSrc={mgsLogo}
          siteName="MICA Grad Show 2020"
        />
      </Back>
      <detail className={id}>
        <div className="flex">
          <MapWrapper>
          <img
            srcSet={`${show3image}?w=2048 2048w,
                     ${show3image}?w=1792 1792w,
                     ${show3image}?w=1536 1536w,
                     ${show3image}?w=1280 1280w,
                     ${show3image}?w=1024 1024w,
                     ${show3image}?w=768 768w,
                     ${show3image}?w=512 512w`}
            src={show3image}
            sizes="(min-width: 48rem) 66.66vw, 100vw"
          />
            {/* <MapContainer> */}
              {/* <DetailMap
                defaultCenter={lat ? { lat, lng } : undefined}
                zoom={zoom}
                locations={locations}
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCWW7BwZB4inhmk-k5RWdXRo2pD-5X--YA&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={
                  <div
                    style={{
                      height: "0",
                      paddingBottom: "100%",
                      position: "relative"
                    }}
                  />
                }
                containerElement={
                  <div
                    style={{
                      height: "0",
                      paddingBottom: "100%",
                      position: "relative"
                    }}
                  />
                }
                mapElement={
                  <div
                    style={{
                      top: "0",
                      bottom: "0",
                      left: "0",
                      right: "0",
                      position: "absolute"
                    }}
                  />
                }
              /> */}
            {/* </MapContainer> */}
            {/* {size(show) > 0 &&
              map(show, ({ documentation }) => (
                <HideMobile>
                  {documentation && size(documentation) > 0 && (
                    <ImageStack collection={documentation} />
                  )}
                </HideMobile>
              ))} */}
              <div>
                <Divider />
                <ShowTitle><a href="https://storage.googleapis.com/mgs-2020.appspot.com/MICA%20Grad%20Show%203%20Curatorial%20Fellows%20Announcement%202020%20(1).pdf" target="_blank">Curatorial Fellows 2020 Biographies</a></ShowTitle>
                <Divider />
                <ShowTitle><a href="https://storage.googleapis.com/mgs-2020.appspot.com/MICA%20Grad%20Show%203%20Curator%20Announcement%202020%20(2).pdf" target="_blank">Curator 2020 Biographies</a></ShowTitle>
                <Divider />
                <Description>
                <p>It is important to pause and acknowledge that this failure to cohere has been abrupt, upsetting, and without absolute remedy. Nevertheless, the presentation of the Grad Show 3 thesis projects has reformed as a digital experience that merits deep exploration and contains the positive possibility of reaching a broader audience than the original format. But perhaps most importantly, we should contemplate that which withstands even these strange and challenging times is the human dialogue extending out from 41 singular studios, the unrelenting probing that is part of making, and the disruptive demand of contemporary art and artists to be seen and pondered not simply despite, but more emphatically because of current circumstances.</p>
                <p>— Kristen Hileman<br/>
                   Independent Curator<br/>
                   Excerpt from MICA GRAD SHOW 3 Curatorial essay: <a href="https://storage.googleapis.com/mgs-2020.appspot.com/MICA%20Grad%20Show%203%202020%20Curatorial%20Essays%20(1).pdf" target="_blank">Read the Full Version Here</a>.
                </p>
                <br/>
                <p>Yet, when we celebrate artistic achievements, we, in fact, applaud all that has come before: blood, sweat, and tears of the practice itself. So even without the finale of the exhibition, we are celebrating just that—the individual practices of emerging artists nurtured and guided by faculty and staff. Sheltering in place, our appreciation for the arts as an essential part of life is magnified and this situation sheds light on the importance of institutions such as MICA whose mission is to inspire, train, and mentor generations of creative practitioners. From wherever each of us may be, join the faculty, staff, and guests, like me, who are lucky enough to have been part of MICA’s community, in congratulating the artists and curators of Class of 2020.</p>
                <p>— Liz Park<br/>
                   Curator, University at Buffalo Art Galleries<br/>
                   Excerpt from MICA GRAD SHOW 3 Curatorial essay: <a href="https://storage.googleapis.com/mgs-2020.appspot.com/MICA%20Grad%20Show%203%202020%20Curatorial%20Essays%20(1).pdf" target="_blank">Read the Full Version Here</a>.
                </p>
                </Description>
                 <Divider />
                <ShowTitle><a href="https://storage.googleapis.com/mgs-2020.appspot.com/MICA%20Grad%20Show%203%202020%20Curatorial%20Essays%20(1).pdf" target="_blank">Curatorial Essays</a></ShowTitle>
                <Divider />

              </div>
          </MapWrapper>
          <InfoContainer>
            <Title>{name}</Title>
            {/* {showDate && <Subtitle className="dateRange">{showDate}</Subtitle>} */}
            {/* {groupType === "City Wide" && firstStudent && firstStudent.name && (
              <Subtitle>{firstStudent.name}</Subtitle>
            )} */}
            <Description
              className="description"
              dangerouslySetInnerHTML={{ __html: description }}
            />
            {/* <LocationList
              show={show}
              reception={reception}
              isShowFilm={isShowFilm}
              isShowThree={isShowThree}
              isShowTwo={isShowTwo}
              program={program}
            />
            {!isShowFilm && extraChild && (
              <LocationList
                show={extraChild.show}
                reception={extraChild.reception}
                isShowThree={isShowThree}
                isShowTwo={isShowTwo}
                program={program}
              />
            )} */}
            {isShowThree && program && <AllStudents program={program} />}
            {!isShowThree &&
              size(show) > 0 &&
              map(show, ({ documentation }) => (
                <HideDesktop>
                  {documentation && size(documentation) > 0 && (
                    <ImageStack collection={documentation} />
                  )}
                </HideDesktop>
              ))}
          </InfoContainer>
        </div>

      </detail>
      {picked && picked.length > 0 && (
          <SlideTitle>Student Work</SlideTitle>
          )}
          {picked && picked.length > 0 && (
          <Slideshow collection={picked} />
         )}
    </Wrapper>
  );
}
DetailEl.propTypes = {
  showGroup: PropTypes.shape({
    description: PropTypes.string,
    gallery: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    ongoing: PropTypes.bool,
    program: PropTypes.object.isRequired,
    receptionDate: PropTypes.string,
    showDate: PropTypes.string,
    name: PropTypes.string.isRequired,
    zoom: PropTypes.number
  }),
  detailClose: PropTypes.func.isRequired
};
DetailEl.defaultProps = {
  showGroup: null
};
export default DetailEl;



// WEBPACK FOOTER //
// ./src/components/Detail/DetailEl.jsx